import {Injectable, Injector} from '@angular/core';
import {LoadingController, ToastController} from "@ionic/angular";
import {Router} from "@angular/router";
import {LangService} from "./lang.service";
@Injectable({
    providedIn: 'root'
})
export class ToastService {
    loading: any;

    constructor(
        public toastController: ToastController,
        private router: Router,
        public loadingController: LoadingController,
        public lang: LangService
    ) {
    }
    async toast(message : string, status = 'error', dismiss = true, redirect: any = null) {
        const toast = await this.toastController.create({
            message,
            color: status === 'error' ? 'danger' : 'success',
            duration: status === 'error' ? 8000 : 4000,
            cssClass: status === 'success' ? 'toast-success' : 'toast-error',
        });
        await toast.present();

        if(dismiss){
            await this.dismissLoading();
        }

        if (redirect !== null) {
            await this.router.navigateByUrl(redirect);
        }
    }
    validateForm(currentForm : any) {
        if (currentForm.invalid) {
            for (const control in currentForm.controls) {
                if (currentForm.controls[control].hasOwnProperty('touched')) {
                    currentForm.controls[control].touched = true;
                }
            }

            this.toast(this.lang.data['error.form_not_completed']);
            return true;
        }
        return false;
    }
    async showLoading(){
        this.loading = await this.loadingController.create({message: 'Loading...'});
        await this.loading.present();
        return 1;
    }
    async dismissLoading() {
        await this.loading.dismiss();
        return 1;
    }
    async toastGeneralError(){
        const toast = await this.toastController.create({
            message: this.lang.data['error.server_error'],
            color:  'danger',
            duration: 8000,
            cssClass: 'toast-error',
        });
        await toast.present();
        await this.loading.dismiss();
    }


    async toastComingSoon() {
        const toast = await this.toastController.create({
            message: this.lang.data['coming_soon'],
            color:  'success',
            duration: 3000,
            cssClass: 'toast-success',
        });
        await toast.present();
        await this.loading.dismiss();
    }
}
